import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { countries_data } from "../constants/countries";

// ---------------- INTERFACES ----------------
export interface Country {
  name: string;
  dial_code: string;
  code: string;
  flag?: string;
}

export interface CustomPhoneInputProps {
  value?: string;
  onChange: (value: string) => void;

  country?: Country | null;
  onCountryChange?: (country: Country | null) => void;

  error?: string;

  placeholder?: string;

  countries?: Country[];
  defaultCountryCode?: string;
  disabled?: boolean;
}

// ---------------- DEFAULT DATA ----------------
const DEFAULT_COUNTRIES: Country[] = countries_data;

// ---------------- COMPONENT ----------------
const CustomPhoneNumber: React.FC<CustomPhoneInputProps> = ({
  value,
  onChange,
  country,
  onCountryChange,
  error,
  placeholder,
  countries = DEFAULT_COUNTRIES,
  defaultCountryCode = "+91",
  disabled
}) => {
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);

  useEffect(() => {
    if (!country) {
      const defaultCountry = countries.find(
        (c) => c.dial_code === defaultCountryCode
      ) || null;

      setSelectedCountry(defaultCountry);
      onCountryChange?.(defaultCountry);
    } else {
      setSelectedCountry(country);
    }
  }, [country, countries, defaultCountryCode]);

  return (
    <div>
      <div className="p-inputgroup gap-2">

        <Dropdown
          value={selectedCountry}
          options={countries}
          optionLabel="name"
          filter
          disabled={disabled}
          filterBy="name,dial_code"
          placeholder="Country"
          className="max-w-[7rem]"
          onChange={(e) => {
            setSelectedCountry(e.value);
            onCountryChange?.(e.value);
          }}
          itemTemplate={(option: Country) => (
            <span>{option.name} ({option.dial_code})</span>
          )}
          valueTemplate={(option: Country) =>
            option ? <span>{option.dial_code}</span> : "Select"
          }
        />

        <InputText
          value={value || ""}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          keyfilter="int"
          placeholder={placeholder || "Phone number"}
        />

      </div>

      {error && <small className="text-red-500">{error}</small>}
    </div>
  );
};

export default CustomPhoneNumber;